import { useEffect, useState } from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'
import styled from 'styled-components'

// local imports
import logo from 'assets/images/koc-logo.svg'
import FirmService from '../../service/FirmService'
import CampusService, { ICampusServiceExists } from 'service/CampusService'
import ChartCardPage from './chart-templates/chartcardpage/ChartCardPage'
import Summary from './chart-templates/summary-page/StatisticsSummary'

export default function DashboardHomePage() {
  const employee = JSON.parse(localStorage.getItem('employee') || '[]')
  const userInfo_ = employee.authList.filter((item: any) => item.controller === 'Dashboard')
  const [userInfo] = useState<any>(userInfo_.find((item: any) => item.action === 'SuperAdmin'))
  const [firmList, setFirmList] = useState<any>([])
  const [loading, setLoading] = useState(false)
  /* Campus Services Visibility - Check */
  const [campusVisible, setCampusVisible] = useState<ICampusServiceExists | undefined>()

  useEffect(() => {
    setLoading(true)
    FirmService.getAllFirmList()
      .then((r: any) => {
        setFirmList(r.data || [])
        CampusService.getCampusServiceExists().then((r) => setCampusVisible(r.data))
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return showLoading()

  return (
    <>
      <div className="row">
        {firmList.length > 0 && (
          <Summary
            userInfo={userInfo !== undefined ? userInfo.Action : 'LocationAdmin'}
            firmList={firmList}
            campusVisible={campusVisible}
          />
        )}
      </div>

      <div className="row mt-3 mb-5">
        {firmList.length > 0 && (
          <ChartCardPage
            userInfo={userInfo !== undefined ? userInfo.Action : 'LocationAdmin'}
            firmList={firmList}
            campusVisible={campusVisible}
          />
        )}
      </div>
    </>
  )
}

export const showLoading = () => {
  return (
    <LoaderWrapper className="loading">
      <ProgressSpinner style={{ position: 'absolute', width: '140px', zIndex: 1102 }} />
      <img
        alt="loading-list"
        style={{ position: 'absolute', width: '65px', height: '65px', zIndex: 1102 }}
        src={logo}
      />
    </LoaderWrapper>
  )
}

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: 1102;
`
